
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";
var state = store._modules.root._children.auth.state;
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      
      Companies: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchCompanies: null,
      CompaniesSearchMode: false,
      searchModel: "",
      state: state,
    };
  },
  methods: {
    addCompanies() {
      console.log("**********####", this.state);
      var data = {
        title: "popups.addCompanies",
        inputs: [
        {"model":"name",
"type":"text",
"label":"companies.name"},
{"model":"surveylink",
"type":"text",
"label":"companies.surveylink"},
{"model":"thankyoulink",
"type":"text",
"label":"companies.thankyoulink"},
{"model":"created_at",
"type":"text",
"label":"companies.created_at"},
{"model":"updated_at",
"type":"text",
"label":"companies.updated_at"},

        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("companies", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editCompanies(app) {
      var data = {
        title: "popups.companies",
        inputs: [
         {"model":"name",
"type":"text",
"label":"companies.name",
"value":app.name
},
    {"model":"surveylink",
"type":"text",
"label":"companies.surveylink",
"value":app.surveylink
},
    {"model":"thankyoulink",
"type":"text",
"label":"companies.thankyoulink",
"value":app.thankyoulink
},
    {"model":"created_at",
"type":"text",
"label":"companies.created_at",
"value":app.created_at
},
    {"model":"updated_at",
"type":"text",
"label":"companies.updated_at",
"value":app.updated_at
},
    
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("companies", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    updateCompanies(app) {
      var data = {
        title: "popups.editfile",
        inputs: [
        {"model":"name",
"type":"text",
"label":"companies.name"},
{"model":"surveylink",
"type":"text",
"label":"companies.surveylink"},
{"model":"thankyoulink",
"type":"text",
"label":"companies.thankyoulink"},
{"model":"created_at",
"type":"text",
"label":"companies.created_at"},
{"model":"updated_at",
"type":"text",
"label":"companies.updated_at"},

        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              obj.emp_id = app.id;
              this.http.do("companies", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    search() {
      this.CompaniesSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("companies/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "",
        })
        .then((res) => {
          this.Companies = res.data;
          console.log("######## files", this.Companies);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.CompaniesSearchMode = false;
      this.get(this.page);
    },
   
    getCompanies() {
      this.http.get("companies").then((res) => {
        this.Companies = res.data;
      });
    },
    deleteCompanies(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("companies", app.id).then(() => {
            console.log("############################3");
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("companies/paginate", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.Companies = res.data;
          
        });
    },
  },
  created() {
    this.get(1);
    this.getCompanies();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.companies.text')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @keyup="search()"
              type="text"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          class="btn-close text-light"
          v-if="CompaniesSearchMode"
          @click="cancelappsearchMode()"
        ></button>
        <button
          type="button"
          @click="addCompanies()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
        <th scope='col'>{{$t('companies.id')}}
</th><th scope='col'>{{$t('companies.name')}}
</th><th scope='col'>{{$t('companies.surveylink')}}
</th><th scope='col'>{{$t('companies.thankyoulink')}}
</th><th scope='col'>{{$t('companies.created_at')}}
</th><th scope='col'>{{$t('companies.updated_at')}}
</th> 
        <th scope='col'>{{$t('companies.operations')}}
</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(app) in Companies" :key="app" class="text-center">
          <td>{{app.name}}</td><td>{{app.surveylink}}</td><td>{{app.thankyoulink}}</td><td>{{app.created_at}}</td><td>{{app.updated_at}}</td>
          
          <td class="d-flex">
            <a
              class="btn btn-primary mx-1"
              @click="editCompanies(app)"
              href="javascript: void(0);"
              role="button"
              >{{ $t("popups.edit") }}</a
            >
            <a
              class="btn btn-danger"
              href="javascript: void(0);"
              role="button"
              @click="deleteCompanies(app)"
              >{{ $t("popups.delete") }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div v-if="tot_pages == 20">
      <!--   Apps  paginate     -->
      <ul class="paginate paginate-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == total_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>




